import { useState } from "react";
import { FaCirclePlus } from "react-icons/fa6";
import { FaEdit, FaTrash } from "react-icons/fa";
import BioPopupModal from "@/components/common/BioPopupModal/BioPopupModal";
import ConfirmationModel from "@/components/common/ConfirmationModel/ConfirmationModel";
import "./BioSection.css";

const BioSection = ({ bio = "", onSave, onDelete, isSaving = false }) => {
  const [showBioModal, setShowBioModal] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);

  const hasBio = bio && bio.trim().length > 0;

  const handleAddClick = () => {
    setShowBioModal(true);
  };

  const handleEditClick = () => {
    setShowBioModal(true);
  };

  const handleDeleteClick = () => {
    setShowDeleteConfirmation(true);
  };

  const handleSave = async (bioText) => {
    try {
      await onSave(bioText);
      setShowBioModal(false);
    } catch (error) {
      // Keep modal open on error - error toast is handled by parent
    }
  };

  const handleConfirmDelete = async () => {
    try {
      await onDelete();
      setShowDeleteConfirmation(false);
    } catch (error) {
      // Error toast is handled by parent
      setShowDeleteConfirmation(false);
    }
  };

  return (
    <div className="bio-section">
      <div className="bio-section-header">
        <span className="bio-section-title">Bio</span>
        <div className="bio-section-actions">
          {hasBio ? (
            <>
              <button
                type="button"
                className="bio-action-btn"
                onClick={handleEditClick}
                disabled={isSaving}
                aria-label="Edit bio"
              >
                <FaEdit className="bio-action-icon" /> Edit
              </button>
              <span className="bio-action-separator">|</span>
              <button
                type="button"
                className="bio-action-btn bio-delete-btn"
                onClick={handleDeleteClick}
                disabled={isSaving}
                aria-label="Delete bio"
              >
                <FaTrash className="bio-action-icon" /> Delete
              </button>
            </>
          ) : (
            <button
              type="button"
              className="bio-action-btn"
              onClick={handleAddClick}
              disabled={isSaving}
              aria-label="Add bio"
            >
              <FaCirclePlus className="bio-action-icon" /> Add Bio
            </button>
          )}
        </div>
      </div>

      {hasBio && (
        <div className="bio-section-preview">
          <p className="bio-preview-text">
            {bio.length > 150 ? `${bio.substring(0, 150)}...` : bio}
          </p>
        </div>
      )}

      <BioPopupModal
        show={showBioModal}
        onHide={() => setShowBioModal(false)}
        bio={hasBio ? bio : ""}
        mode="edit"
        onSave={handleSave}
        isSaving={isSaving}
      />

      <ConfirmationModel
        show={showDeleteConfirmation}
        onHide={() => setShowDeleteConfirmation(false)}
        title="Delete Bio"
        content="Are you sure you want to delete your bio? This action cannot be undone."
        onYes={handleConfirmDelete}
        onNo={() => setShowDeleteConfirmation(false)}
        yesButtonText="Delete"
        noButtonText="Cancel"
      />
    </div>
  );
};

export default BioSection;
